<div class="link-header row space-between">
  <span class="col-11 header-main">
    <span class="link-header-name">LINKS</span>
    @if (!readOnly) {
      <button mat-icon-button color="primary" (click)="addLink()">
        <mat-icon>add_box</mat-icon>
      </button>
    }
  </span>
  <button
    type="button"
    class="col-1 expand-button"
    [ngClass]="shouldExpand ? 'expand' : 'collapse'"
    (click)="shouldExpand = !shouldExpand"
    >
    <mat-icon>expand_more</mat-icon>
  </button>
</div>
@if (dashboardType == 'committee') {
  <div>
    <button mat-button class="link-header-close-dash-btn" (click)="navigateToClosingDashboard()"><mat-icon>close_fullscreen</mat-icon>Closing Dashboard</button>
  </div>
}
<div class="all-links-container expand">

  <div class="row link-container">
    <div class="col-md-6">
      <div class="row">
        <div class="top-link col-6 col-md-3">
          <mat-icon>home_work</mat-icon>
          <a href="{{ deal.projecturl }}" target="_blank">CREAWeb</a>
        </div>
        @if (deal.sharepointfolder !== null) {
          <div
            class="top-link col-6 col-md-3"
            >
            <mat-icon>folder</mat-icon>
            <a
            href="https://creallc.sharepoint.com/sites/{{
              deal.sharepointfolder
            }}"
              target="_blank"
              >SharePoint</a
              >
            </div>
          }
          @if (deal.islinked) {
            <div class="top-link col-6 col-md-3">
              <mat-icon>contact_mail</mat-icon>
              <a
            href="https://crealink.crm.dynamics.com/main.aspx?appid=bc296e3f-15c7-ec11-a7b6-0022482937ce&pagetype=entityrecord&etn=crea_deal&id={{
              deal.projectid
            }}"
                target="_blank"
                >CREALink</a
                >
              </div>
            }
            @if (deal.project.teams_url) {
              <div class="top-link col-6 col-md-3">
                <mat-icon>chat</mat-icon>
                <a href="{{ deal.project.teams_url }}" target="_blank">Teams</a>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div
      class="all-links-container"
      [ngClass]="shouldExpand ? 'expand' : 'collapse'"
      >
      @if (deal.committeeLinks.length > 0) {
        <div class="row link-rows">
          <div class="col-md-8">
            @for (link of deal.committeeLinks; track link; let i = $index) {
              <div
                class="row align-top"
                >
                <div class="col-3 col-md-2" [ngClass]="{ edit: link.editMode }">
                  @if (!link.editMode) {
                    <span>{{
                      link.milestone_id === -1 || link.milestone_id === null
                      ? link.name
                      : getMilestoneLabel(link.milestone_id)
                    }}</span>
                  }
                  @if (link.editMode) {
                    <form class="input-container">
                      <mat-form-field>
                        <mat-label>Type</mat-label>
                        <mat-select
                          [ngModel]="link.milestone_id"
                (ngModelChange)="
                  link.milestone_id = $event;
                  $event !== -1
                    ? (link.name = getMilestoneLabel($event))
                    : (link.name = '')
                "
                          name="milestoneId"
                          required
                          >
                          @for (milestone of milestones; track milestone) {
                            <mat-option
                              [value]="milestone.id"
                              >{{ getMilestoneLabel(milestone.id) }}</mat-option
                              >
                            }
                            <mat-option [value]="-1">Other</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </form>
                    }
                  </div>
                  @if (link.editMode && link.milestone_id === -1) {
                    <div
                      class="col-3 col-md-2"
                      [ngClass]="{ edit: link.editMode }"
                      >
                      @if (link.editMode) {
                        <form class="input-container">
                          @if (link.milestone_id === -1) {
                            <mat-form-field
                              class="input-box"
                              appearance="fill"
                              >
                              <mat-label>Name</mat-label>
                              <input
                                matInput
                                placeholder="Name"
                                name="name"
                                [(ngModel)]="link.name"
                                required
                                />
                            </mat-form-field>
                          }
                        </form>
                      }
                    </div>
                  }
                  <div
                    class="col-5 col-md-7 url"
                    [ngClass]="{ 'url-edit': link.editMode }"
                    >
                    @if (!link.editMode) {
                      <a (click)="goTo(link.url)">{{ link.url }}</a>
                    }
                    @if (link.editMode) {
                      <form class="input-container">
                        <mat-form-field class="input-box" appearance="fill">
                          <mat-label>URL</mat-label>
                          <input
                            matInput
                            placeholder="URL"
                            name="url"
                            [(ngModel)]="link.url"
                            required
                            />
                        </mat-form-field>
                      </form>
                    }
                  </div>
                  <div class="col-3 col-md-1 edit-icons">
                    @if (!readOnly) {
                      <button
                        mat-icon-button
            [disabled]="
              waiting ||
              (link.editMode &&
                (link.name === null ||
                  link.name === '' ||
                  link.url === null ||
                  link.url === ''))
            "
                        (click)="updateLink(link, i)"
                        >
                        @if (!link.editMode) {
                          <mat-icon>edit</mat-icon>
                        }
                        @if (link.editMode) {
                          <mat-icon>check</mat-icon>
                        }
                      </button>
                    }
                    @if (!link.is_default_link && !link.editMode && !readOnly) {
                      <button
                        mat-icon-button
                        [disabled]="waiting"
                        (click)="deleteLink(link, i)"
                        >
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
